const strings = {
  labels: {
    editContactsButton: 'Edit Contact Methods',
    viewAll: 'View All Contact Methods',
    viewAllButton: 'View All',
  },
} as const;

export default strings;
